import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './components/Layout';
import Dashboard from './pages/Dashboard';
import UserManagement from './pages/UserManagement';
import DoctorManagement from './pages/DoctorManagement';
import VolunteerManagement from './pages/VolunteerManagement';
import DoctorVolunteerSwitch from './pages/DoctorVolunteerSwitch';
import QuestionnaireManagement from './pages/QuestionnaireManagement';
import QuestionnaireApproval from './pages/QuestionnaireApproval';
import ApproverManagement from './pages/ApproverManagement';
import ProjectManagement from './pages/ProjectManagement';
import LaborSignatureManagement from './pages/LaborSignatureManagement';
import LaborDetailManagement from './pages/LaborDetailManagement';
import ProjectLaborDetailIndex from './pages/ProjectLaborDetailIndex';
import Login from './pages/Login';
import PrivateRoute from './components/PrivateRoute';

const ResponsiblePortalNotFound: React.FC = () => (
  <div style={{
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f5f5f5',
    color: '#262626'
  }}>
    <div style={{ fontSize: 96, fontWeight: 700, lineHeight: 1 }}>404</div>
    <div style={{ marginTop: 20, fontSize: 20 }}>页面不存在</div>
  </div>
);

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/responsible-login" element={<ResponsiblePortalNotFound />} />
        <Route path="/responsible/project" element={<ResponsiblePortalNotFound />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <MainLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="users" element={<UserManagement />} />
          <Route path="survey-subjects">
            <Route path="doctors" element={<DoctorManagement />} />
          </Route>
          <Route path="volunteers" element={<VolunteerManagement />} />
          <Route path="doctor-volunteer-switch" element={<DoctorVolunteerSwitch />} />
          <Route path="projects">
            <Route path="survey" element={<ProjectManagement />} />
          </Route>
          <Route path="labor-management">
            <Route path="signatures" element={<LaborSignatureManagement />} />
          </Route>
          <Route path="project-labor-detail-index" element={<ProjectLaborDetailIndex />} />
          <Route path="labor-detail-management/:projectId" element={<LaborDetailManagement />} />
          <Route path="questionnaires" element={<QuestionnaireManagement />} />
          <Route path="questionnaire-approval" element={<QuestionnaireApproval />} />
          <Route path="approver-management" element={<ApproverManagement />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
